import { render, staticRenderFns } from "./PartnersScreen.vue?vue&type=template&id=3bc9a40f&scoped=true&"
import script from "./PartnersScreen.vue?vue&type=script&lang=ts&"
export * from "./PartnersScreen.vue?vue&type=script&lang=ts&"
import style0 from "./PartnersScreen.vue?vue&type=style&index=0&id=3bc9a40f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc9a40f",
  null
  
)

export default component.exports